module.exports = __webpack_public_path__ + "static/media/10 Niranjan MIR Brief.1602423b.pdf";